import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { GetApproachList } from "../../apis/user/get_approach_list";

export default function ApproachList({ userId }) {
    const navigate = useNavigate();
    const [appData, setAppData] = useState([]);
    const [getAppApi, setGetAppApi] = useState(API_STATUS);

    useEffect(() => {
        GetApproachList(userId, setGetAppApi);
    }, []);

    useEffect(() => {
        setAppData([]);
        if (!getAppApi.isLoader && !getAppApi.isError && getAppApi.data != null) {
            if (getAppApi.data.status === 1) {
                
                setAppData(getAppApi.data.data);
            }
        }
    }, [getAppApi]);

    return <div className="pt-5 md:max-w-[510px] mx-auto" >
        {

            appData.map((items) =>
                <Link to={'/approach_details/'+items.id} key={items.id} style={{ backgroundColor: '#fff',display:"block" }} className="mb-2">

                    <div className="flex gap-4 items-center p-2">


                        <div className="relative md:w-20 md:h-20 w-12 h-12 shrink-0">

                            <label for="file" className="cursor-pointer">
                                <img id="img" src={items.userPic} className="object-cover w-full h-full rounded-full" alt="" />

                            </label>



                        </div>

                        <div className="flex-1">
                            <h3 className="md:text-xl text-base font-semibold text-black dark:text-white"> {items.firstName + ' ' + items.lastName} </h3>
                            <p className="text-sm text-blue-600 mt-1 font-normal">{items.subCat}</p>
                        </div>

                    </div>
                    <p className="p-3">{items.regard}</p>
                </Link>
            )
        }

    </div>
}